export default __webpack_public_path__ + "static/media/gallery2.d78c1c33.jpg";